import TableCell, { TableCellProps } from '@mui/material/TableCell';
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';

// Survey selection truncates the cell itself; other tables truncate a text child.
// Inspect both so all tables use the same overflow-only tooltip behaviour.
function truncatedText(cell: HTMLElement): string {
    const elements = [cell, ...Array.from(cell.querySelectorAll<HTMLElement>('*'))];
    for (const element of elements) {
        const style = getComputedStyle(element);
        if (style.textOverflow === 'ellipsis'
            && (style.overflowX === 'hidden' || style.overflowX === 'clip' || style.overflow === 'hidden')
            && element.clientWidth > 0
            && element.scrollWidth > element.clientWidth) {
            return element.textContent?.trim() ?? '';
        }
    }
    return '';
}

export default function TruncatedTableCell({ children, onMouseEnter, onMouseLeave, ...props }: TableCellProps) {
    const [tooltip, setTooltip] = useState('');

    return (
        <Tooltip
            title={tooltip}
            open={Boolean(tooltip)}
            placement="top"
            arrow
            describeChild
            disableHoverListener
            disableFocusListener
            disableTouchListener
            disableInteractive
            onClose={() => setTooltip('')}
        >
            <TableCell
                {...props}
                onMouseEnter={event => {
                    setTooltip(truncatedText(event.currentTarget));
                    onMouseEnter?.(event);
                }}
                onMouseLeave={event => {
                    setTooltip('');
                    onMouseLeave?.(event);
                }}
            >
                {children}
            </TableCell>
        </Tooltip>
    );
}
